import { getTracking } from "ts-tracking-number";

import { BUTTONS } from "src/utils/styles";

interface FulfillmentTrackingProps {
  tracking: string;
  trackingUrl?: string;
}

export default function FulfillmentTracking({
  tracking,
  trackingUrl,
}: FulfillmentTrackingProps) {
  // if trackingUrl is provided, use it, otherwise call getTracking
  let url = null;
  if (trackingUrl) {
    url = trackingUrl;
  } else {
    const trackingObject = getTracking(tracking);
    url =
      trackingObject?.trackingUrl?.replace(
        "%s",
        trackingObject.trackingNumber
      ) || null;
  }
  if (!url) return <span>{tracking}</span>;

  return (
    <a
      href={url || "#"}
      target="_blank"
      rel="noreferrer"
      className={BUTTONS.text}
    >
      {tracking}
    </a>
  );
}
